/* @ngInject */
function ConfirmationDialogController ($scope, $sce) {
  $scope.loading = false
  $scope.description = $sce.trustAsHtml($scope.data.description)
  $scope.htmlDescription = $sce.trustAsHtml($scope.data.htmlDescription)

  $scope.handleConfirmButtonClick = () => {
    $scope.loading = true
    const returnConfirm = $scope.data.onConfirm()

    if (returnConfirm && typeof returnConfirm.then === 'function') {
      returnConfirm
        .then(() => {
          $scope.close(true)
        })
        .finally(() => {
          $scope.loading = false
        })

      return
    }

    $scope.close(true)
  }

  $scope.handleCancelButtonClick = () => {
    $scope.data.onCancel()
    $scope.close(false)
  }
}

export { ConfirmationDialogController }
